import React, { useState, useEffect } from "react";
import { Spinner, Form } from "react-bootstrap";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const SelectLivrosFiscaisFormik = ({ formik, field }) => {
  const [documentoFiscal, setDocumentoFiscal] = useState([]);
  const [showErro, setshowErro] = useState(false);
  const [messageErro, setMessageErro] = useState("");

  const { request, data, errors, isLoading } = useApiClient();

  const { values } = formik;

  useEffect(() => {
    if (values.tpCategoria)
      request(apiRoutes.fiscalizacao.ocorrencia.consultaDocumentosFiscais, { tpCategoria: values.tpCategoria });
  }, [request, values.tpCategoria]);

  useEffect(() => {
    if (data) setDocumentoFiscal(data.result);

    if (errors) {
      setMessageErro(errors.message);
      setshowErro(true);
    }
  }, [data, errors]);

  return (
    <>
      {showErro && (
        <>
          <br />
          <div className="alert alert-danger" role="alert">
            {messageErro}
          </div>
        </>
      )}
      {isLoading ? (
        <span>
          <Spinner animation="border" role="status" />
          &nbsp;Carregando ...
        </span>
      ) : (
        <>
          <Form.Control
            as="select"
            id={field}
            name={field}
            disabled={formik.isSubmitting}
            value={formik.values[field]}
            onChange={formik.handleChange}
            isInvalid={formik.touched[field] && formik.errors[field]}
          >
            <option key="0" value="">
              Selecione
            </option>
            {documentoFiscal.map((item) => (
              <option key={item.cdDocumento} value={item.cdDocumento}>
                {item.nomeLivro}
              </option>
            ))}
          </Form.Control>
          {formik.touched[field] && formik.errors[field] && (
            <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
          )}
        </>
      )}
    </>
  );
};

export default SelectLivrosFiscaisFormik;
